module.exports = __webpack_public_path__ + "assets/fonts/THSMoneyfont-Medium.b3a64104.otf";